import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=065375c5&scoped=true&"
import script from "./UsersManagement.vue?vue&type=script&lang=js&"
export * from "./UsersManagement.vue?vue&type=script&lang=js&"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=065375c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065375c5",
  null
  
)

export default component.exports